import { AnyAction } from 'redux';
import { put } from 'redux-saga/effects';

import * as actions from '@/store/actions';
import { apiClient } from '@/utils';
import { AxiosResponse } from 'axios';
import { getRangeForLabel, startOfDay, endOfDay, toDate } from '@/utils/datetime';

export function* fetchBookingUserQueue({ payload = {} }: AnyAction) {
    try {
        let { start: DateStart, end: DateEnd } = getRangeForLabel(payload._Date);

        // Manual override with explicit dates, if provided
        if (payload.DateStart) {
            DateStart = startOfDay(payload.DateStart);
        }
        if (payload.DateEnd) {
            DateEnd = endOfDay(payload.DateEnd);
        }

        // Custom single-day selection
        if (payload._Date === 'custom' && payload._CustomDate) {
            const date = toDate(payload._CustomDate);
            DateStart = startOfDay(date);
            DateEnd = endOfDay(date);
        }

        const { _Date, _CustomDate, CompanyQueueItems, ...rest } = payload;

        const response: AxiosResponse = yield apiClient.get('/bookinguserqueue/user', {
            params: {
                IncludeServiceInformation: true,
                IncludeCompanyInformation: true,
                IncludeCustomerInformation: true,
                ...rest,
                CompanyQueueItems: true,
                DateStart,
                DateEnd,
            },
        });

        const raw = response.data as any;

        // Normalise API response into the paged list shape expected by createListLoadingReducer
        // 1) If backend returns standard QueryResponse: { Results: [], Total, ... } we keep it
        // 2) If backend returns an array, wrap it
        // 3) If backend returns an object with numeric keys (e.g. { "0": {...}, "1": {...} })
        //    convert it to an array via Object.values
        let results: any[] = [];

        if (raw) {
            if (Array.isArray(raw.Results)) {
                results = raw.Results;
            } else if (Array.isArray(raw)) {
                results = raw;
            } else if (typeof raw === 'object') {
                results = Object.values(raw);
            }
        }

        const normalisedPayload = {
            Results: results,
            Total: typeof raw?.Total === 'number' ? raw.Total : results.length,
            Take: raw?.Take,
            Skip: raw?.Skip,
        };

        yield put(actions.FETCH_BOOKING_USER_QUEUE.success(normalisedPayload));
    } catch (error) {
        yield put(actions.FETCH_BOOKING_USER_QUEUE.failure(error));
    }
}
